import { Container123 } from "./styles";
import { images } from "../../assets";

function NavLinkbar() {

  return (
    <Container123>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "0.3rem",
        }}
      >
        <img
          src={images.logoHorizontalTeuCard}
          alt="Logo da empresa"
        />
        <span>Versão: {process.env.REACT_APP_VERSAO_APP}</span>
      </div>
    </Container123>
  );
}

export default NavLinkbar;
